import { LoginDto } from 'modules/auth/libs/types';
import { ZodType, z } from 'zod';

export const LoginSchema: ZodType<LoginDto> = z.object({
  email: z.string().min(1, '이메일을 입력해주세요.').email('이메일 형식이 올바르지 않습니다.'),
  password: z.string().min(1, '비밀번호를 입력해주세요.'),
  referrer: z.string().optional(),
});
